export default __webpack_public_path__ + "assets/models/5c1f741b50c88d469d3afebe0357d346.glb";